import { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import MembershipRegister from "./MembershipRegister";
import PaymentHistory from "./PaymentHistory";
import SubmissionActivity from "./SubmissionActivity";
import ShopOrders from "./ShopOrders";
import ExportFirestoreData from "./ExportFirestoreData";
import { ToastProvider } from "./Toast";
import { InboxProvider, useInbox } from "./Inbox";
import "./admin.css";

const TABS = [
  { id: "register", label: "Membership register", title: "Membership administration", Component: MembershipRegister },
  { id: "payments", label: "Payment history", title: "Payment history", Component: PaymentHistory },
  { id: "activity", label: "Submission activity", title: "Submission activity", Component: SubmissionActivity, badge: "newApps" },
  { id: "orders", label: "Shop orders", title: "Shop orders", Component: ShopOrders, badge: "newOrders" },
  { id: "export", label: "Data export", title: "Data export", Component: ExportFirestoreData },
];

function AtomLogo() {
  return (
    <svg className="na-atom" viewBox="0 0 64 64" width="46" height="46" aria-hidden="true">
      <g className="na-atom-spin">
        <ellipse cx="32" cy="32" rx="26" ry="10" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <ellipse cx="32" cy="32" rx="26" ry="10" fill="none" stroke="currentColor" strokeWidth="1.6" transform="rotate(60 32 32)" />
        <ellipse cx="32" cy="32" rx="26" ry="10" fill="none" stroke="currentColor" strokeWidth="1.6" transform="rotate(120 32 32)" />
        <circle cx="58" cy="32" r="3" fill="#c9a53b" />
        <circle cx="45" cy="54.5" r="3" fill="#c9a53b" />
        <circle cx="19" cy="54.5" r="3" fill="#c9a53b" />
      </g>
      <circle className="na-atom-core" cx="32" cy="32" r="5" fill="#c9a53b" />
    </svg>
  );
}

function Shell() {
  const [tab, setTab] = useState("register");
  const [navOpen, setNavOpen] = useState(false);
  const inbox = useInbox();
  const active = TABS.find((t) => t.id === tab);
  const Active = active.Component;
  const attention = inbox.newApps + inbox.newOrders;

  return (
    <div className="nsk-admin">
      <aside className={`na-sidebar ${navOpen ? "open" : ""}`}>
        <div className="na-brand">
          <AtomLogo />
          <div>
            <strong>NSK</strong>
            <span>Nuclear Society of Kenya</span>
          </div>
        </div>
        <p className="na-nav-label">Membership office</p>
        <nav>
          {TABS.map((t) => {
            const count = t.badge ? inbox[t.badge] : 0;
            return (
              <button
                key={t.id}
                className={t.id === tab ? "active" : ""}
                onClick={() => {
                  setTab(t.id);
                  setNavOpen(false);
                }}
              >
                {t.label}
                {count > 0 && <span className="na-count" aria-label={`${count} waiting`}>{count}</span>}
              </button>
            );
          })}
        </nav>
        <div className="na-side-foot">
          <small>{auth.currentUser?.email}</small>
          <button onClick={() => signOut(auth)}>Sign out</button>
        </div>
      </aside>

      <main className="na-main">
        <div className="na-topbar">
          <button className="na-burger" onClick={() => setNavOpen(!navOpen)} aria-label="Menu">
            ☰{attention > 0 && <span className="na-dot-alert" />}
          </button>
          <span>
            NSK / <strong>{active.title}</strong>
          </span>
        </div>
        <div className="na-content">
          <Active />
        </div>
      </main>
    </div>
  );
}

export default function AdminDashboard() {
  return (
    <ToastProvider>
      <InboxProvider>
        <Shell />
      </InboxProvider>
    </ToastProvider>
  );
}
